import { Box, Button, Divider, Grid2, Typography } from '@mui/material';
import { timeOptions } from 'constants/genral';
import { useUserSearchContext } from 'context/UserSearchContext';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UserSearch } from 'types';
interface TimeSelectorProp {
  fieldName: string;
}
export const TimeSelector: React.FC<TimeSelectorProp> = ({ fieldName }) => {
  const { bookingSearchData, setBookingSearchData } = useUserSearchContext();
  const navigate = useNavigate();

  const [displaytime, setDisplaytime] = useState<Date | string>();

  const timeSelectionHandler = (time: string) => {
    setDisplaytime(time);

    const parts = time.match(/(\d+):(\d+) (\w+)/);
    const objectKey =
      fieldName === 'pickup-time' ? 'pickupDisplayTime' : 'returnDisplayTime';

    const objectKeyTime =
      fieldName === 'pickup-time' ? 'pickupTime' : 'returnTime';

    const bookingTime: string | Date =
      fieldName === 'pickup-time'
        ? bookingSearchData.OutDetails.Time
        : bookingSearchData.InDetails.Time;

    const updatedTime = new Date(bookingTime);

    if (parts) {
      let hours = parseInt(parts[1], 10);
      const minutes = parseInt(parts[2], 10);
      const period = parts[3];

      // Adjust hours for AM/PM
      if (hours === 12 && period === 'AM') {
        hours = 0; // midnight case
      } else if (hours !== 12 && period === 'PM') {
        hours += 12; // Convert PM hour to 24-hour format except for 12 PM itself
      }

      // Set the extracted and adjusted hours and minutes to the date
      updatedTime.setHours(hours, minutes, 0, 0);
    }

    if (fieldName === 'pickup-time') {
      setBookingSearchData((prev) => ({
        ...prev,
        OutDetails: {
          ...bookingSearchData.OutDetails,
          Time: time,
        },
        VehicleModel: { ...prev.VehicleModel },
        IPLocation: { ...prev.IPLocation },
        insuranceChargeCode: [...prev.insuranceChargeCode],
        ancilarriesChargeCode: [...prev.ancilarriesChargeCode],
        chargeCodes: [...prev.chargeCodes],
        activeBranchId: '',
        branchType: '',
      }));
    } else {
      setBookingSearchData((prev) => ({
        ...prev,
        InDetails: {
          ...bookingSearchData.InDetails,
          Time: time,
        },
        activeBranchId: '',
        branchType: '',
      }));
    }
    navigate(-1);
  };

  useEffect(() => {
    if (bookingSearchData.OutDetails && bookingSearchData.InDetails) {
      setDisplaytime(
        fieldName === 'pickup-time'
          ? bookingSearchData.OutDetails.Time
          : bookingSearchData.InDetails.Time
      );
    }
  }, [bookingSearchData]);

  return (
    <Box sx={{ padding: 2 }}>
      {timeOptions.map((option, index) => (
        <>
          <Box sx={{ marginBottom: 2 }} key={index}>
            <Typography
              variant="h6"
              sx={{
                marginBottom: 1,
                color: '#fff !important',
                textAlign: 'left !important',
              }}
            >
              {option.label}
            </Typography>
            <Grid2 container spacing={2}>
              {option.times.map((time, timeIndex: number) => (
                <Grid2
                  size={2}
                  key={timeIndex}
                  sx={{
                    width: 'auto',
                    minWidth: '150px',
                    maxWidth: '150px',
                  }}
                >
                  <Button
                    className={
                      bookingSearchData &&
                      (time === displaytime
                        ? 'time-btn active-time-btn'
                        : 'time-btn')
                    }
                    onClick={() => timeSelectionHandler(time)}
                    // color={time === selectedTime ? "primary" : "secondary"}
                  >
                    {time}
                  </Button>
                </Grid2>
              ))}
            </Grid2>
          </Box>
          <Divider
            sx={{
              backgroundColor: 'lightgray',
              height: '1px',
              marginTop: '50px',
              marginBottom: '50px',
            }}
          />
        </>
      ))}
    </Box>
  );
};
